module.exports = __webpack_public_path__ + "static/media/Fenny.c8eb96d6.webp";